module.exports = __webpack_public_path__ + "static/media/2_move_slides.eca0419e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/2_move_slides.mp4
// module id = 309
// module chunks = 0